// extracted by mini-css-extract-plugin
export var bullet = "_s2-q";
export var bulletText = "_s2-p";
export var bullets = "_s2-k";
export var callout = "_s2-g";
export var calloutBody = "_s2-i";
export var calloutLabel = "_s2-h";
export var checkIcon = "_s2-m";
export var checkList = "_s2-j";
export var checkSvg = "_s2-n";
export var checkText = "_s2-o";
export var fieldCard = "_s2-1";
export var fieldDescription = "_s2-5";
export var fieldHeader = "_s2-3";
export var fieldTitle = "_s2-4";
export var finalNote = "_s2-s";
export var flow = "_s2-x";
export var flowArrow = "_s2-v";
export var flowStep = "_s2-u";
export var helperText = "_s2-r";
export var inlineTitle = "_s2-t";
export var listItem = "_s2-l";
export var noteBody = "_s2-8";
export var noteBodyText = "_s2-9";
export var noteCard = "_s2-2";
export var noteIcon = "_s2-6";
export var noteTitle = "_s2-7";
export var productChoices = "_s2-w";
export var radioDot = "_s2-d";
export var radioDotSelected = "_s2-e";
export var radioDotSvg = "_s2-f";
export var selectableCard = "_s2-b";
export var selectableCardSelected = "_s2-c";
export var strongText = "_s2-a";
export var subHeading = "_s2-0";